import Axios from 'axios'

export const searchCollectors = async (searchParams) => {
  const response = await Axios.post('/collectors/search', searchParams)
  return response.data
}

export const getCollector = async (id) => {
  const response = await Axios.get(`/collectors/${id}`)
  return response.data
}

export const getCollectorClients = async (collectorId, searchParams) => {
  const response = await Axios.post(`/collectors/${collectorId}/clients/search`, searchParams)
  return response.data
}

export const addClientToCollector = async (collectorId, clientId) => {
  const response = await Axios.post(`/collectors/${collectorId}/clients/${clientId}`)
  return response.data
}

export const removeClientFromCollector = async (collectorId, clientId) => {
  const response = await Axios.delete(`/collectors/${collectorId}/clients/${clientId}`)
  return response.data
}

export const updateCollectorRecipients = async (params) => {
  const response = await Axios.post('/collectors/updateRecipients', params)
  return response.data
}
